import './Subtitle.less';
import { useContext, useState, useEffect, useRef } from 'react';
import { EditContext } from '@/context/EditContext';
import OriginalTranslate from './originaltranslate/OriginalTranslate';
import BilingualTranslate from './bilingualtranslate/BilingualTranslate';
import { useTranslation } from 'react-i18next';
import { projectController } from '@/api/edit';
import {
  setOriginalSubtitleRestructure,
  setTranslationTTSRestructure,
  setBilingualSubtitleRestructure,
} from '@/pages/edit/utils/subtitleSegmentation';
import { modifySegmenteSubtitle } from '@/components/Timeline/command.ts';
// import { Slider } from '@radix-ui/themes';
import Slider from '@mui/material/Slider';
import UpdateAll from '@/assets/edit/updateAll.svg';
export default function Subtitle() {
  const { t } = useTranslation();
  const {
    sessionId,
    useTranslate,
    activeTab,
    subtitleScroll,
    setSubtitleScroll,
    setSubtitleHover,
    timelinePlaybackTime,
    isPlaying,
    subtitleSegmentationCount,
    setSubtitleSegmentationCount,
    translationMaterial,
    setTranslationMaterial,
    sentenceMaterial,
    setSentenceMaterial,
    projectDetail,
    mode,
    setSentenceTranslationPopup,
  } = useContext(EditContext);
  const [scrollTime, setScrollTime] = useState(null);
  const subtitleMainRef = useRef();
  const [updateAllShow, setUpdateAllShow] = useState(false);
  const [updateAllFlag, setUpdateAllFlag] = useState(false);
  const [sliderDisabled, setSliderDisabled] = useState(false);
  const [sliderFoucs, setSliderFoucs] = useState(false);
  const [keyDownFlag, setKeyDownFlag] = useState(false);
  const handleTranslateSubtitle = useRef();
  useEffect(() => {
    if (!subtitleScroll) {
      const subtitleMain = document.querySelector('.subtitle_main');
      const activeSentenceItem = document.querySelector('.subtitle_active');
      const activeSentenceHeight = activeSentenceItem ? activeSentenceItem.offsetHeight : 0;
      if (activeSentenceItem && subtitleMain) {
        const distanceToTop =
          activeSentenceItem.getBoundingClientRect().top - subtitleMain.getBoundingClientRect().top;

        if (distanceToTop < 0 || distanceToTop + activeSentenceHeight > subtitleMain.clientHeight) {
          subtitleMain.scrollTop = subtitleMain.scrollTop + distanceToTop; // 滚动到activeSentenceItem到subtitleMain最顶部
        }
      }
    }
  }, [document.querySelector('.subtitle_active'), timelinePlaybackTime, activeTab, subtitleScroll]);

  useEffect(() => {
    console.log(sentenceMaterial, translationMaterial, 'sentenceMaterialtranslationMaterial');
    if (sentenceMaterial?.details) {
      const screenHasOrigionalGenerating = sentenceMaterial.details.some(
        (item) => item.generating === true,
      );
      if (!screenHasOrigionalGenerating) {
        setSliderDisabled(false);
      } else {
        setSliderDisabled(true);
      }
    }
    if (translationMaterial?.details) {
      const screenHasBilingalGenerating = translationMaterial.details.some(
        (item) => item.generating === true,
      );
      const hasGenerating = translationMaterial.details.some((item) => item.translating === true);
      if (!screenHasBilingalGenerating && !hasGenerating) {
        setSliderDisabled(false);
      } else {
        setSliderDisabled(true);
      }
    }
    if (sentenceMaterial?.details && translationMaterial?.details) {
      const hasIsEdit = sentenceMaterial.details.some((item) => item.subtitleEdit === true);
      if (hasIsEdit) {
        setUpdateAllFlag(false);
        setUpdateAllShow(true);
      } else {
        const hasGenerating = translationMaterial.details.some((item) => item.translating === true);
        if (hasGenerating) {
          setUpdateAllFlag(true);
        } else {
          setUpdateAllShow(false);
        }
      }
    }
  }, [sentenceMaterial, translationMaterial]);

  const handleWheel = () => {
    if (isPlaying) {
      setSubtitleScroll(true);
      setScrollTime((prevTime) => {
        clearTimeout(prevTime); // 清除之前的计时器
        return setTimeout(() => {
          setSubtitleScroll(false);
        }, 2000);
      }); // 重新开始计时
    }
  };

  useEffect(() => {
    const speechMain = subtitleMainRef.current;
    if (speechMain) {
      speechMain.addEventListener('wheel', handleWheel);
    }
    return () => {
      if (speechMain) {
        speechMain.removeEventListener('wheel', handleWheel);
        clearTimeout(scrollTime);
        setScrollTime(null);
      }
    };
  }, [isPlaying]);
  const handleSliderChangeComplete = (val) => {
    if (mode === 'translation_and_tts') {
      const { original, bilingual } = setTranslationTTSRestructure(
        sentenceMaterial.details,
        translationMaterial.details,
        val,
        projectDetail.language,
        projectDetail.translationLanguage,
      );
      translationMaterial.details = bilingual;
      sentenceMaterial.details = original;
      setSentenceMaterial({ ...sentenceMaterial });
      setTranslationMaterial({ ...translationMaterial });
      modifySegmenteSubtitle(1, { ...translationMaterial });
    } else {
      if (mode === 'translation' || mode === 'add_subtitle_and_translation') {
        const { original, bilingual } = setBilingualSubtitleRestructure(
          sentenceMaterial.details,
          translationMaterial.details,
          val,
          projectDetail.language,
          projectDetail.translationLanguage,
        );
        translationMaterial.details = bilingual;
        sentenceMaterial.details = original;
        setSentenceMaterial({ ...sentenceMaterial });
        setTranslationMaterial({ ...translationMaterial });
        modifySegmenteSubtitle(0, { ...sentenceMaterial });
      } else {
        if (mode === 'narration') {
          sentenceMaterial.details = setOriginalSubtitleRestructure(
            sentenceMaterial.details,
            val,
            sentenceMaterial.details[0].language,
          );
        } else {
          sentenceMaterial.details = setOriginalSubtitleRestructure(
            sentenceMaterial.details,
            val,
            projectDetail.language,
          );
        }

        setSentenceMaterial({ ...sentenceMaterial });
        modifySegmenteSubtitle(0, { ...sentenceMaterial });
      }
    }
    const projectItem = JSON.parse(sessionStorage.getItem('projectItem'));
    try {
      projectController.updateCharNum({
        projectId: projectItem.id,
        charNum: val,
      });
    } catch (error) {
      console.log(error);
    }
  };

  const handleUpdateAll = (errorCallback) => {
    setUpdateAllFlag(true);
    sentenceMaterial.details.filter((detail, index) => {
      if (detail.subtitleEdit) {
        translationMaterial.details[index].translating = true;
        translationMaterial.details[index].subtitleEdit = false;
      }
    });
    sentenceMaterial.details.filter((detail) => {
      if (detail.subtitleEdit) {
        detail.subtitleEdit = false;
        detail.translating = true;
      }
    });
    setSentenceMaterial({ ...sentenceMaterial });
    setTranslationMaterial({ ...translationMaterial });
    const projectItem = JSON.parse(sessionStorage.getItem('projectItem'));
    try {
      projectController.batchTranslation({ sessionId, projectId: projectItem.id });
    } catch (error) {
      console.log(error);
      setUpdateAllFlag(false);
      errorCallback();
    }
  };

  useEffect(() => {
    const handleKeyUp = (event) => {
      setKeyDownFlag(false);
      if (
        sliderFoucs &&
        (event.key === 'ArrowUp' ||
          event.key === 'ArrowDown' ||
          event.key === 'ArrowLeft' ||
          event.key === 'ArrowRight')
      ) {
        handleSliderChangeComplete(subtitleSegmentationCount);
      }
    };
    const handleKeyDown = (event) => {
      if (
        event.key === 'ArrowUp' ||
        event.key === 'ArrowDown' ||
        event.key === 'ArrowLeft' ||
        event.key === 'ArrowRight'
      ) {
        setKeyDownFlag(true);
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    window.addEventListener('keyup', handleKeyUp);

    return () => {
      window.removeEventListener('keyup', handleKeyUp);
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [sliderFoucs, subtitleSegmentationCount]);

  const TranslateSubtitle = () => {
    let num = 0;
    sentenceMaterial.details.filter((detail) => {
      if (detail.subtitleEdit) {
        num += 1;
      }
    });
    setSentenceTranslationPopup(true);
    handleTranslateSubtitle.current({}, num, 'all');
  };
  return (
    <div className="subtitle_box">
      <div className="subtitle_header_box">
        <div className="subtitle_title_box">
          <div className="subtitle_title">{t('As_Edit_SpaceSubtitle334')}</div>
          {updateAllShow && (
            <div
              className={`subtitle_translate_updateall ${!updateAllFlag && 'subtitle_translate_updateall_hover'}`}
              onClick={() => {
                !updateAllFlag && TranslateSubtitle();
              }}>
              {t('As_Edit_TranslateAll334')}
              {updateAllFlag ? (
                <span className="loading loading-spinner loading-xs"></span>
              ) : (
                <img src={UpdateAll} alt="" />
              )}
            </div>
          )}
        </div>

        <div className="subtitle_range">
          <div className="subtitle_range_title">{t('As_Edit_SubtitleNum334')}</div>
          <div className="subtitle_range_slider">
            <Slider
              min={6}
              disabled={sliderDisabled}
              max={100}
              value={subtitleSegmentationCount ?? 0}
              onChange={(_, val) => {
                setSubtitleSegmentationCount(val);
              }}
              onChangeCommitted={(_, val) => {
                console.log(val, '123213');
                // console.log(keyDownFlag, val, 'keyDownFlagkeyDownFlagkeyDownFlag');
                !keyDownFlag && handleSliderChangeComplete(val);
              }}
              onFocus={() => {
                setSliderFoucs(true);
              }}
              onBlur={() => {
                console.log('Slider失去聚焦');
                setSliderFoucs(false);
              }}
            />
          </div>
          <div className="subtitle_range_num">{subtitleSegmentationCount}</div>
        </div>
      </div>
      <div
        className="subtitle_main"
        ref={subtitleMainRef}
        onMouseEnter={() => {
          setSubtitleHover(true);
        }}
        onMouseLeave={() => {
          setSubtitleHover(false);
        }}>
        {useTranslate && (
          <BilingualTranslate
            handleTranslateAll={(fn) => {
              handleTranslateSubtitle.current = fn;
            }}
            handleUpdateAll={(errorCallback) => {
              handleUpdateAll(errorCallback);
            }}
          />
        )}
        {!useTranslate && <OriginalTranslate />}
      </div>
    </div>
  );
}
